"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = void 0;
const walk_1 = require("../walk");
function updateObjectViaPathString(obj, path, delimiter, val) {
    const block = path.split(delimiter).slice(1);
    while (block.length > 1)
        obj = obj[block.shift()];
    obj[block.shift()] = val;
}
function deepCopy(target, delimiter = '$walk:dc$') {
    if (target === null)
        return null;
    const newObj = Array.isArray(target) ? [] : {};
    const format = ({ key }) => delimiter + key;
    (0, walk_1.walk)(target, {
        onVisit: [{
                timing: 'preVisit',
                filters: [n => !n.isRoot],
                callback: (node) => updateObjectViaPathString(newObj, node.getPath(format), delimiter, node.nodeType === 'array'
                    ? []
                    : (node.nodeType === 'value'
                        ? node.val
                        : (node.val === null
                            ? null
                            : {})))
            }]
    });
    return newObj;
}
exports.deepCopy = deepCopy;
